
const GalleryEndpoints = {

	galleryWidgetRandom: "/random?r.art_number=3&r.writing_number=3&r.year=2023&r.page=0",
	galleryRandom: "/random?r.art_number=8&r.writing_number=8&r.year=2023&r.page=0" ,
	galleryRandomNoPage: "/random?r.art_number=8&r.writing_number=8&r.year=2023&r.page="
	
}

export default GalleryEndpoints